type DownloadCSVProps = {
  data: any[];
  filename?: string;
};

export const downloadCSV = ({
  data,
  filename = 'download.csv',
}: DownloadCSVProps) => {
  // Convert data to CSV string
  const headers = Object.keys(data[0]).join(',');
  const csvRows = data.map((item) =>
    Object.values(item)
      .map((value) =>
        typeof value === 'string' && value.includes(',') ? `"${value}"` : value
      )
      .join(',')
  );
  const csvString = [headers, ...csvRows].join('\n');

  // Create a Blob with the CSV data
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  // Create a download link and trigger the download
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
